<template>
  <v-dialog v-if="orderDialog" v-model="orderDialog" persistent transition="dialog-bottom-transition">
    <v-container fluid grid-list-sm>
      <v-toolbar color="White">
        <v-toolbar-title class="headline">Partneri koji su poručili promotivni proizvod</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-spacer></v-spacer>
      <v-data-table
        :mobile-breakpoint="breakpoint"
        :headers="headers"
        :items="tableData"
        :items-per-page="itemsPerPage"
        :footer-props="{itemsPerPageOptions: [8,10,20,30,50]}"
        :loading-text="$t('loading_data')"
        class="elevation-1"
        sort-by="name"
        :loading="tableDataLoading"
      >
        <!----------------------------------- ## FILTERS ## ------------------------------------>
        <template v-slot:body.prepend>
          <tr class="grey lighten-2">
            <th v-for="header in headers"
                :key="header.name"
                class="py-2">
              <v-text-field
                v-model="filters[header.value]"
                @keyup.enter.native="search"
                label="Filter"
                :placeholder="header.text"
                filled
                hide-details
                style="padding: 0; font-size: inherit; text-align: right !important;"
              ></v-text-field>
            </th>
          </tr>
        </template>
        <!-------------------------------- ## NO DATA ## ----------------------------------->
        <template v-slot:no-data>
          <div class="text-xs-center">
            <v-alert color="error" icon="mdi-alert-circle-outline">
              {{errorMessage}}
            </v-alert>
          </div>
        </template>
      </v-data-table>
      <!---------------------------------- Snackbar  ----------------------------------------->
      <v-snackbar
        v-model="snackbar.show"
        :bottom=true
        :color="snackbar.color"
        :timeout="snackbar.timeout">
        {{ snackbar.text }}
        <v-btn dark text @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>

      <v-card-actions class="white" align="right">
        <div class="flex-grow-1"></div>
        <v-btn class="mr-4" text color="primary" dark @click="closeDialog(-1)">
          {{$t('close')}}
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-dialog>
</template>

<script>
  import {
    addEmit,
    editEmit,
    findById,
    onDelete, readPartnersActive,
    readTableData,
    readTableDataById,
    refresh,
    search
  } from "../../statics/DataTableFunctions";
  import axios from "axios";

  export default {
    props: {
      orderDialog: false,
      dataForModal: null
    },
    name: "ChooseItemDialog",
    data() {
      return {
        translation: 'partners',
        selectedId: -1,
        selected: [],
        tableData: [],
        defaultActive: '',
        deleteLoadingId: -1,
        breakpoint: 500,
        addItemDialog: false,
        partners: [],
        editItemDialog: false,
        tableDataLoading: false,
        filteredTableData: [],
        loading: false,
        filters: {
          is_active: '',
        },
        itemsPerPage: 8,
        errorMessage: this.$t('no_data'),
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
        rules: {
          required_number: [value => {
            const pattern = /^[0-9]\d{0,9}(\.\d{1,3})?%?$/
            return pattern.test(value) || this.$t(this.translation + '.number')
          }]
        },
      }
    },
    methods: {
      search,
      closeDialog() {
        this.$emit('close');
      },
    },
    computed: {
      activeObjects() {
        return [
          {value: "", text: this.$t('all')},
          {value: 'true', text: this.$t('active')},
          {value: 'false', text: this.$t('not_active')},
        ]
      },
      headers() {
        return [
          {text: this.$t(this.translation + '.id'), name: 'id', align: 'left', value: 'partner.id', width: '150px'},
          {text: this.$t(this.translation + '.name'), name: 'name', align: 'left', value: 'partner.name', width: '350px'},
          {text: this.$t(this.translation + '.categories'), name: 'categories', align: 'left', value: 'partner.category_names', width: '450px'},
          {text: this.$t(this.translation + '.quantity'), name: 'quantity', align: 'left', value: 'quantity', width: '450px'},
        ]
      },
    },
    watch: {
      orderDialog: function (val) {
        if (val) {
          this.tableData = this.dataForModal;
        }
      },
    },
  }
</script>

<style scoped/>
